import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";

import Header from "./components/header/index.js";
import Main from "./components/main/index.js";
import AboutUs from "./components/about-us/index.js";
import Gallery from "./components/gallery/index.js";
import Footer from "./components/footer/index.js";
import Comment from "./components/comment/index.js";
import BgHeader from "./assets/icons/bg-header.png";
import "./App.css";

function App() {
  const [showSidbarMarginLeft, setShowSidbarMarginLeft] = useState();
  const location = useLocation();
  return (
    <div
      className={`${
        showSidbarMarginLeft !== undefined
          ? showSidbarMarginLeft === true
            ? "content-class"
            : "content-class2"
          : ""
      }  font-IRANSansWeb  `}
    >
      <div
        style={{
          backgroundImage: `url(${BgHeader})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
        }}
        className={`  bg-center 
        
        ${location.pathname !== "/" ? "" : "sticky top-0  "}
        `}
      >
        <Header
          setShowSidbarMarginLeft={setShowSidbarMarginLeft}
          showSidbarMarginLeft={showSidbarMarginLeft}
        />
      </div>
      <div className="">
        <Routes>
          <Route
            path="/"
            element={<Main showSidbarMarginLeft={showSidbarMarginLeft} />}
          />
          <Route
            path="/about-us"
            element={<AboutUs showSidbarMarginLeft={showSidbarMarginLeft} />}
          />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/comment" element={<Comment />} />
        </Routes>
      </div>
      {/* location.pathname !== "/" ? "fixed bottom-0 w-full" : "sticky " */}
      <footer className={`sticky top-0`}>
        {/* ${
          (location.pathname === "/about-us" ||
            location.pathname === "/forms" ||
            location.pathname === "/queue-sysem") &&
          "fixed bottom-0 w-full"
        } */}
        <Footer showSidbarMarginLeft={showSidbarMarginLeft} />
      </footer>
    </div>
  );
}

export default App;
